var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcPasswordMarkHover = function SvgIcPasswordMarkHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    enableBackground: "new 0 0 18 10",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    transform: "translate(-1 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    transform: "translate(1 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    fill: "#65A844",
    d: "M0.818,8.333h16.364V10H0.818V8.333z M1.759,4.958l0.7-1.233l0.7,1.233l1.064-0.625 L3.523,3.1h1.386V1.85H3.518l0.7-1.225L3.15,0l-0.7,1.225L1.759,0L0.7,0.625L1.4,1.85H0V3.1h1.391l-0.7,1.233L1.759,4.958z  M7.241,4.333l1.064,0.625l0.7-1.233l0.7,1.233l1.064-0.625L10.068,3.1h1.392V1.85h-1.396l0.699-1.225L9.7,0L9,1.225L8.3,0 L7.236,0.625l0.7,1.225H6.545V3.1h1.391L7.241,4.333z M18,1.85h-1.391l0.699-1.225L16.241,0l-0.7,1.225L14.85,0l-1.063,0.625 l0.7,1.225h-1.396V3.1h1.392l-0.7,1.233l1.063,0.625l0.7-1.233l0.7,1.233l1.064-0.625L16.609,3.1H18V1.85z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcPasswordMarkHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_password_mark_hover.8cf922db247e86032c5a007fe471d6fc.svg";